import { render, staticRenderFns } from "./signUpsuccess.vue?vue&type=template&id=4b215d03&scoped=true&"
import script from "./signUpsuccess.vue?vue&type=script&lang=js&"
export * from "./signUpsuccess.vue?vue&type=script&lang=js&"
import style0 from "./signUpsuccess.vue?vue&type=style&index=0&id=4b215d03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b215d03",
  null
  
)

export default component.exports